import {Button} from "@progress/kendo-react-buttons"
import {MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle} from "mdbreact"
import {useDispatch} from "react-redux"
import {deleteCustomPrice, showDeleteModal} from "../../containers/CustomPrices/customPricesSlice"
import {RootState} from "../../rootReducer"
import {LoadingPanel, SpinnerFragment} from "../../shared/CommonItems"
import {useAppSelector} from "../../store"

const DeleteModel = () => {
    const dispatch = useDispatch()
    const selectedRegion = useAppSelector((state: RootState) => state.application.selectedRegion)
    const selectedCustomPrice = useAppSelector(
        (state: RootState) => state.containers.customPrices.selectedCustomPriceName,
    )
    const selectedCustomPriceDeleteId = useAppSelector(
        (state: RootState) => state.containers.customPrices.selectedCustomPriceDeleteId,
    )

    const showDeleteLoader = useAppSelector((state: RootState) => state.containers.customPrices.showDeleteLoader)
    const DeleteModal = useAppSelector((state: RootState) => state.containers.customPrices.showDeleteModal)
    const LoadingOverviewPanel = () => {
        return (
            <div className="d-flex justify-content-center grid-center-spinner">
                <div className="k-loading-mask" style={{fontSize: "8px"}}>
                    <span className="k-loading-text">Loading</span>
                    <div className="k-loading-image"></div>
                    <div className="k-loading-color"></div>
                </div>
            </div>
        )
    }
    return (
        <div>
            <MDBModal staticBackdrop show={DeleteModal} tabIndex="-1">
                <MDBModalDialog position="modal-sm">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                <MDBModalTitle>Delete Custom Price</MDBModalTitle>
                            </MDBModalTitle>
                            <MDBBtn
                                color="none"
                                className="btn-close"
                                onClick={() => dispatch(showDeleteModal(false))}
                            ></MDBBtn>
                        </MDBModalHeader>
                        {showDeleteLoader && <LoadingOverviewPanel />}
                        <MDBModalBody>
                            <span>Are you sure you want to delete {selectedCustomPrice}?</span>
                            <div className="d-flex justify-content-end mt-2">
                                <Button
                                    fillMode={"flat"}
                                    themeColor={"primary"}
                                    style={{lineHeight: "1rem", padding: "4px 10px"}}
                                    onClick={() =>
                                        dispatch(
                                            deleteCustomPrice(selectedCustomPriceDeleteId, selectedRegion.regionId),
                                        )
                                    }
                                    title="Yes"
                                >
                                    Yes
                                </Button>
                                <Button
                                    fillMode={"flat"}
                                    themeColor="primary"
                                    title="No"
                                    onClick={() => {
                                        dispatch(showDeleteModal(false))
                                    }}
                                    style={{lineHeight: "1rem", padding: "4px 10px"}}
                                    className="ms-2"
                                >
                                    No
                                </Button>
                            </div>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    )
}

export default DeleteModel
